import { render, staticRenderFns } from "./CashierTotal.vue?vue&type=template&id=56702bbd&scoped=true"
import script from "./CashierTotal.vue?vue&type=script&lang=ts"
export * from "./CashierTotal.vue?vue&type=script&lang=ts"
import style0 from "./CashierTotal.vue?vue&type=style&index=0&id=56702bbd&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56702bbd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56702bbd')) {
      api.createRecord('56702bbd', component.options)
    } else {
      api.reload('56702bbd', component.options)
    }
    module.hot.accept("./CashierTotal.vue?vue&type=template&id=56702bbd&scoped=true", function () {
      api.rerender('56702bbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cashier/CashierTotal.vue"
export default component.exports